export const PAYMENT_FREQUENCIES = ["DAILY", "WEEKLY", "MONTHLY"];

export const normalizeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const normalizePositiveNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const normalizePaymentFrequency = (value) => {
  const normalized = String(value || "MONTHLY").toUpperCase();
  return PAYMENT_FREQUENCIES.includes(normalized) ? normalized : "MONTHLY";
};

export const formatDisplayDate = (value) => {
  if (!value) {
    return "-";
  }

  const normalizedValue =
    value?.$date ||
    value?.iso ||
    value?.value ||
    value?.date ||
    value;

  const parsedDate = new Date(normalizedValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(normalizedValue);
  }

  return parsedDate.toLocaleDateString();
};

export const getPaymentPlanOptions = (source) => ({
  DAILY: normalizePositiveNumber(source?.DAILY ?? source?.daily),
  WEEKLY: normalizePositiveNumber(source?.WEEKLY ?? source?.weekly),
  MONTHLY: normalizePositiveNumber(source?.MONTHLY ?? source?.monthly),
});

export const getPaymentModeFromEnrollment = (enrollment) => {
  const paymentPlan = enrollment?.paymentPlan || {};
  const selectedFrequency = normalizePaymentFrequency(
    paymentPlan?.selectedPaymentFrequency ||
      enrollment?.selectedPaymentFrequency ||
      enrollment?.paymentFrequency
  );
  const isFlexiblePayment =
    paymentPlan?.isFlexiblePayment === true || enrollment?.isFlexiblePayment === true;

  if (selectedFrequency === "MONTHLY" && !isFlexiblePayment) {
    return "PAYMENT_PLAN";
  }

  return "LEDGER";
};

export const getEnrollmentPaymentDetails = (enrollment) => {
  const paymentPlan = enrollment?.paymentPlan || {};
  const selectedPaymentFrequency = normalizePaymentFrequency(
    paymentPlan?.selectedPaymentFrequency ||
      enrollment?.selectedPaymentFrequency ||
      enrollment?.paymentFrequency
  );
  const selectedPaymentAmount = normalizePositiveNumber(
    paymentPlan?.selectedPaymentAmount ||
      enrollment?.selectedPaymentAmount ||
      enrollment?.installmentAmount ||
      enrollment?.emiAmount ||
      enrollment?.monthlyEmi ||
      enrollment?.emi
  );
  const payableNow = normalizePositiveNumber(
    paymentPlan?.payableNow || enrollment?.payableNow || selectedPaymentAmount
  );
  const paidAmount = normalizePositiveNumber(paymentPlan?.paidAmount || enrollment?.paidAmount || enrollment?.paid);
  const totalAmount = normalizePositiveNumber(enrollment?.totalAmount || enrollment?.total);
  const remainingAmount = normalizePositiveNumber(
    paymentPlan?.remainingAmount ||
      enrollment?.remainingAmount ||
      Math.max(totalAmount - paidAmount, 0)
  );
  const paymentPlanOptions = getPaymentPlanOptions(
    paymentPlan?.paymentPlanOptions ||
      enrollment?.paymentPlanOptions ||
      enrollment?.planOptions
  );
  const mode = getPaymentModeFromEnrollment(enrollment);
  const flexible = mode === "LEDGER";

  return {
    selectedPaymentFrequency,
    selectedPaymentAmount,
    payableNow,
    nextDueDate: paymentPlan?.nextDueDate || enrollment?.nextDueDate || "",
    paidAmount,
    remainingAmount,
    paymentPlanOptions,
    isFlexiblePayment: flexible,
    mode,
    allowAmountEdit: Boolean(
      paymentPlan?.allowAmountEdit ||
        enrollment?.allowAmountEdit ||
        enrollment?.allowFlexibleAmountEdit
    ),
    canChangePlan: flexible,
  };
};